module.exports = __webpack_public_path__ + "img/202311231455580056an.5f31cb26.jpg";